import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import { useIsCopilotWidgetActive } from 'copilot-toolkit/hooks/useIsCopilotWidgetActive';
import { useSendMessageFromAppToCopilot } from 'copilot-toolkit/hooks/useSendCollaboration';
import { useGetAiAccessControls } from 'academy-common-lib/features/aiControl/aiAccessQueries';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const usePlaylistAIButton = ({
  messageText,
  mode
}) => {
  const {
    aiAccessControls,
    loading: aiAccessLoading
  } = useGetAiAccessControls();
  const sendMessageFromAppToCopilot = useSendMessageFromAppToCopilot();
  const isCopilotReady = useIsCopilotWidgetActive();
  const isCopilotEnabled = (aiAccessControls === null || aiAccessControls === void 0 ? void 0 : aiAccessControls.generativeAiEnabled) && (aiAccessControls === null || aiAccessControls === void 0 ? void 0 : aiAccessControls.copilotEnabled);
  return {
    handleClick: () => {
      sendMessageFromAppToCopilot({
        messageText,
        messageMetaInfo: {
          source: 'ACTION',
          type: 'IN-APP'
        },
        hidden: true
      });
      if (mode === 'edit') {
        UsageTracker.trackStandalone('Playlist Interaction', {
          action: 'edit-playlist-ai-clicked'
        });
      }
      if (mode === 'create') {
        UsageTracker.trackStandalone('Playlist Interaction', {
          action: 'generate-playlist-ai-clicked'
        });
      }
    },
    showButton: !aiAccessLoading && isCopilotEnabled && isCopilotReady
  };
};
export const EditPlaylistAIButton = ({
  variant = 'default'
}) => {
  const {
    handleClick,
    showButton
  } = usePlaylistAIButton({
    messageText: I18n.text('learningCenter.myPlaylists.editPlaylistPrompt'),
    mode: 'edit'
  });
  if (!showButton) {
    return null;
  }
  if (variant === 'inline') {
    return /*#__PURE__*/_jsxs(Button, {
      onClick: handleClick,
      paddingInline: "0",
      use: "transparent",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        compact: true,
        icon: BreezeSingleStarIcon,
        size: "100"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myPlaylists.editPlaylistAI"
      })]
    });
  }
  return /*#__PURE__*/_jsx(AIButton, {
    onClick: handleClick,
    paddingInline: "600",
    usageTracker: UsageTracker.tracker,
    use: "transparent",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myPlaylists.editPlaylistAI"
    })
  });
};
export const GeneratePlaylistAIButton = () => {
  const {
    handleClick,
    showButton
  } = usePlaylistAIButton({
    messageText: I18n.text('learningCenter.myPlaylists.generatePlaylistPrompt'),
    mode: 'create'
  });
  if (!showButton) {
    return null;
  }
  return /*#__PURE__*/_jsx(AIButton, {
    onClick: handleClick,
    paddingInline: "600",
    usageTracker: NOT_USING_TRACKER,
    use: "transparent",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myPlaylists.generatePlaylistAI"
    })
  });
};